package com.iregained.eventapp.components.sections.footer.styles

import com.iregained.eventapp.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.active
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.s

// A clean, simple hover effect for footer links
val FooterLinkStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        Modifier.color(palette.custom.darkText).transition(Transition.of("color", 200.ms))
    }
    hover {
        val palette = colorMode.toSitePalette()
        Modifier.color(palette.brand.primary)
    }
}

val SocialIconStyle = CssStyle {
    base {
        Modifier.transition(Transition.of("all", 200.ms))
    }
    hover {
        Modifier
            .boxShadow(0.px, 6.px, 12.px, color = rgba(0, 0, 0, 0.15))
            .styleModifier { property("transform", "translateY(-4px) scale(1.1)") }
    }
    active {
        Modifier.styleModifier { property("transform", "scale(0.9)") }
    }
}